import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/brands/components/BrandDetailPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ui/Chip.tsx");
